import {fileTypeFromBuffer} from 'file-type'

export const getMagicNumber = (file, length = 4) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        const blob = file.slice(0, length)

        reader.onloadend = () => {
            if (reader.result instanceof ArrayBuffer) {
                const bytes = new Uint8Array(reader.result)
                const hex = Array.from(bytes)
                    .map((b) => b.toString(16).padStart(2, '0'))
                    .join(' ')
                resolve(hex)
            } else {
                reject('Reader result is not an ArrayBuffer')
            }
        }

        reader.onerror = () => reject(reader.error)
        reader.readAsArrayBuffer(blob)
    })
}

export const validateFile = async (file) => {
    const mime = file.type
    const ext = file.name.split('.').pop().toLowerCase()
    const magic = await getMagicNumber(file, 4)

    return checkMimeTypeExtensionAndMagic(mime, ext, magic)
}

const checkMimeTypeExtensionAndMagic = async (mime, ext, magic) => {
    const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf']

    if (!allowedFileTypes.includes(mime)) {
        return false
    }

    const sanitizedMagic = magic.replaceAll(' ', '')

    if (mime === 'application/pdf') {
        if (ext === 'pdf' && sanitizedMagic === '25504446') {
            return true
        }
        return false
    } else if (mime === 'image/jpeg') {
        if ((ext === 'jpg' || ext === 'jpeg') && sanitizedMagic === 'ffd8ffe0') {
            return true
        }
    } else if (mime === 'image/png') {
        if (ext === 'png' && sanitizedMagic === '89504e47') {
            return true
        }
    }

    return false
}

export const validateBase64File = async (base64Data) => {
    const buffer = Buffer.from(base64Data, 'base64')

    const type = await fileTypeFromBuffer(buffer)

    const magicBytes = buffer.slice(0, 4)
    const magic = magicBytes.toString('hex')

    return checkMimeTypeExtensionAndMagic(type?.mime, type?.ext, magic)
}
